































import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../BotProperties/components/Properties/types'
import BaseCondition from '../../../logic/ConditionTypes/BaseCondition'
import BetweenPropertyCondition from '../../../logic/ConditionTypes/BetweenPropertyCondition'
import LabelCondition from '../../../logic/ConditionTypes/LabelConditions/LabelCondition'
import PropertyCondition from '../../../logic/ConditionTypes/PropertyCondition'
import IsSetPropertyCondition
  from '../../../logic/ConditionTypes/SetPropertyConditions/IsSetPropertyCondition'
import SetPropertyCondition from '../../../logic/ConditionTypes/SetPropertyConditions/SetPropertyCondition'
import { ConditionsNodeProps } from '../../../logic/types'
import BetweenConditionView from '../../Sidebar/ConditionView/BetweenConditionView.vue'
import LabelConditionView from './LabelConditionView.vue'
import PropertyConditionView from './PropertyConditionView.vue'
import SetConditionView from './SetConditionView.vue'

@Component({
  components: {
    LabelConditionView,
    SetConditionView,
    PropertyConditionView,
    BetweenConditionView
  },
  data() {
    return {
      LabelCondition,
      SetPropertyCondition,
      PropertyCondition,
      BetweenPropertyCondition
    }
  }
})
export default class SampleNodeConditionsView extends Vue {
  @Prop() condition!: BaseCondition

  @Prop() labels!: ConditionsNodeProps['labels']

  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() i18n!: i18n
}
